/* mix.js */

"use strict";
class MixinBuilder {
    constructor(superclass) {
        this.superclass = superclass;
    }

    with(...mixins) {
        return mixins.reduce((c, mixin) => {
            return mixin(c);
        }, this.superclass);
    }
}
module.exports = (superclass) => {
    return new MixinBuilder(superclass);
};
